import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { TundishHeatMetricReducer as TundishHeatMetricReducer } from "../reducers/TundishHeatMetricReducer";

const TundishHeatMetricContext = createContext({
	state: TundishHeatMetricReducer.getInitialState(),
	actions: TundishHeatMetricReducer.actions,
});

export const useTundishHMContext = () => useContext(TundishHeatMetricContext);

export const TundishHMProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: TundishHeatMetricReducer.getInitialState(),
		reducers: TundishHeatMetricReducer.caseReducers,
	});
	return (
		<TundishHeatMetricContext.Provider value={{ state, actions }}>
			{children}
		</TundishHeatMetricContext.Provider>
	);
};
